// extracted by mini-css-extract-plugin
export default {"main":"NewEssayView_main__NAbk9"};